import { removeFalsy } from '#component/project/project-log/helper';
import { parseQueryState } from '#helper';

/**
 * Build search params
 * @param {string} params - current search params.
 * @param {Array|Object} newParams - new search params.
 * @returns {string} - merged search params
 */

export const getSearchParams = (params, newParams) => {
  let searchParams;

  if (!newParams) {
    return '';
  }

  if (Array.isArray(newParams)) {
    const parsedCurrUrl = parseQueryState(params);
    searchParams = new URLSearchParams({
      ...parsedCurrUrl,
      ...{
        user: '',
        project: ''

      }
    });
    const param = {
      user: [],
      project: [],
      page: [],
      order: [],
      orderBy: []
    };
    newParams.forEach(el => {
      const { type, value } = el;
      const lowerCaseType = type.toLowerCase();
      if (searchParams.has(lowerCaseType)) {
        param[lowerCaseType].push(value);
        searchParams.set(lowerCaseType, `${param[lowerCaseType].join(',')}`);
      } else {
        searchParams.set(lowerCaseType, value);
      }
    });
  } else {
    searchParams = new URLSearchParams(params);
    const { filterType, value, end, start } = newParams;

    if (filterType && value) {
      searchParams.set(filterType, value);
    }
    if (start && end) {
      searchParams.set('start', start);
      searchParams.set('end', end);
    }
  }

  const currentUrl = parseQueryState(params);
  const newUrl = parseQueryState(searchParams.toString());
  const mergedUrls = { ...currentUrl, ...newUrl };
  const url = new URLSearchParams(removeFalsy(mergedUrls));

  return `${url.toString()}`;
};

const getRootProjectByLevel = directProjects => {
  const minValue = Math.min(...directProjects.map(obj => obj.level));
  return directProjects.filter(obj => obj.level === minValue);
};

export const getUsersWithRootProjects = (users, projects, deviceCount) => users.map(u => {
  if (u.directProjects && u.directProjects.length > 0) {
    const directProjects = u.directProjects.flatMap(userDirectProject => {
      const founded = projects.find(p => p.id === userDirectProject);

      if (!founded) {
        return [];
      }

      return founded;
    });

    const rootProjects = getRootProjectByLevel(directProjects);

    return {
      ...u,
      project: rootProjects,
      devices: (deviceCount.find(dc => dc.id === u.id) || {}).count
    };
  }

  return u;
});
